import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography, { TypographyProps } from '@material-ui/core/Typography';

const Small: React.FC<TypographyProps> = withStyles((theme) => ({
  root: {
    fontSize: theme.typography.pxToRem(12),
    [theme.breakpoints.up('sm')]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
}))(Typography);

export default Small;
